import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectFinancialCockpitDataRefreshVersion = createSelector(
  [selectFinancialCockpitState],
  ({ dataRefreshVersion }) => dataRefreshVersion
)
